module.exports = __webpack_public_path__ + "img/ARK.994cd902.svg";